export const styledDocumentsScroller = {
  display: 'flex',
  pb: 1,
  borderBottom: 1,
  borderColor: 'grey.500',
  alignItems: 'stretch',
};

export const styledDocumentsList = {
  display: 'flex',
  flexGrow: 1,
  overflow: 'auto',
  mx: 2,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  columnGap: '18px',
};
